import { render, staticRenderFns } from "./Ai.vue?vue&type=template&id=064b20a3&scoped=true"
import script from "./Ai.vue?vue&type=script&lang=js"
export * from "./Ai.vue?vue&type=script&lang=js"
import style0 from "./Ai.vue?vue&type=style&index=0&id=064b20a3&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b20a3",
  null
  
)

export default component.exports